<app-auth-header [title]="'Login'" [showMenu]="false"></app-auth-header>
<div class="auth-content">
  <form [formGroup]="loginForm" (ngSubmit)="login()" class="auth-form login-container">
    <div class="standard-error-message" *ngIf="loginFormErrMsg">
      <i class="fa fa-exclamation-triangle"></i>
      <span class="error-text">{{loginFormErrMsg}}</span>
    </div>
    <label>Email Address</label>
    <div class="input-error-wrap">
      <input auto="email-field" class="block" type="text" name="email" formControlName="email" (keyup)="errMsgOff($event)">
      <app-error-msg
        [control]="loginForm.controls['email']"
        [show]="loginForm.controls['email'].touched && loginForm.controls['email'].invalid">
      </app-error-msg>
    </div>
    <label>Password</label>
    <div class="input-error-wrap last-one">
      <input auto="password-field" class="block" type="password" name="password" formControlName="password" (keyup)="errMsgOff($event)">
      <app-error-msg
        [control]="loginForm.controls['password']"
        [show]="loginForm.controls['password'].touched && loginForm.controls['password'].invalid">
      </app-error-msg>
    </div>
    <button auto="login-btn" class="btn block auth-btn" type="submit">Login</button>
    <a auto="request-password-link" class="pull-left auth-link" routerLink="/reset-password">Request Password</a>
    <a auto="contact-us-link" class="pull-right auth-link" href="mailto:eProve@advanc-ed.org?subject=eProve%20strategies%20question">Contact us for login help</a>
  </form>
  <div class="my-journey-container">
    <a [href]="myJourneyUrl" class="my-journey-link">
      <img src="assets/images/login-with-myjourney.svg" alt="myJourney">
    </a>
  </div>
</div>
<p-dialog [(visible)]="displayModal" [modal]="true" styleClass="terms-conditions-dialog">
  <p-header>
      Terms & Conditions
  </p-header>
  <div class="terms-conditions-content">
    <div class="terms-row">
      Please review and agree to the current Terms & Conditions to continue using eProve&trade; strategies
    </div>
    <div class="terms-row">
      <div class="checkbox checkbox-branded">
          <input type="checkbox" id="accept-terms" [(ngModel)]="agreeToTerms"/>
          <label for="accept-terms"></label>
      </div>
      <span>I agree to the </span>
      <a class="blue-link" href="http://www.advanc-ed.org/sites/default/files/documents/eProve%2BTerms%2Band%2BConditions.pdf" target="_blank">terms & conditions.</a>
    </div>
    <div class="buttons-row">
      <button class="btn btn-alt" (click)="declineTerms()">Cancel</button>
      <button class="btn" (click)="acceptTerms()" [disabled]="!agreeToTerms">Continue</button>
    </div>
  </div>
</p-dialog>
